import type { ReactNode } from 'react'

/** A read-only table. No outer border — the card around it is the box — and it
 *  scrolls inside its own container so the page never does.
 *
 *  `relative` is load-bearing, not decoration. An `sr-only` span is
 *  `position: absolute`, so without a positioned ancestor here its containing
 *  block is the page: the "Actions" label in the last header cell of a 672px
 *  table was laid out at x=581 on a 360px phone and stretched the *document*
 *  to 582px, giving the whole app a horizontal scrollbar that no visible
 *  element accounted for. Positioning this wrapper keeps such a span inside the
 *  scroller it belongs to. */
export function DataTable({ label, children }: { label?: string; children: ReactNode }) {
  return (
    <div className="relative overflow-x-auto overscroll-x-contain">
      <table aria-label={label} className="w-full border-collapse text-sm [&_tbody_td]:border-t [&_tbody_td]:border-line-soft [&_tbody_td]:px-4 [&_tbody_td]:py-3 [&_tbody_td]:align-top [&_tbody_tr:hover_td]:bg-hover [&_thead_th]:bg-subtle [&_thead_th]:px-4 [&_thead_th]:py-3 [&_thead_th]:text-left [&_thead_th]:text-2xs [&_thead_th]:font-semibold [&_thead_th]:tracking-wide [&_thead_th]:whitespace-nowrap [&_thead_th]:text-fg-muted [&_thead_th]:uppercase">
        {children}
      </table>
    </div>
  )
}
